import React, { Component } from "react";
import LeadDetailsDisplay from "../components/procpectingDetailPge/LeadDetailsDisplay";
import { TriggerContextProvider } from "../Context/TriggerContext";

export class ProspectingTrackerDetailsPage extends Component {
  render() {
    return (
      <div style={{ width: "100%" }}>
        <TriggerContextProvider>
          <LeadDetailsDisplay />
        </TriggerContextProvider>
      </div>
    );
  }
}

export default ProspectingTrackerDetailsPage;
